import React from 'react';
import EmailBroadcastDashboard from './EmailBroadcastDashboard';

const EmailBroadcast = ({ teamDetails }) => {
    return (
        <div>
            <EmailBroadcastDashboard teamDetails={teamDetails} />
        </div>
    );
};

export default EmailBroadcast;
